import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { inviteUsers } from '../../../store/actions/share'
import { VIEWER } from '../../../constants'
import { emailRegex } from 'variables'
import { Formik, Form } from 'formik'
import InviteForm from './InviteForm'

const mapStateToProps = null
const mapDispatchToProps = (dispatch, { item }) => ({
  inviteUsers: (users, level) => dispatch(inviteUsers(item, users, level))
})

export class InviteFormContainer extends Component {
  state = { focus: false, showing: false }
  render() {
    return (
      <Formik
        render={props => (
          <Form>
            <InviteForm
              {...props}
              focused={this.state.focus}
              focus={() => {
                this.setState({ focus: true })
              }}
              showing={this.state.showing}
              show={() => {
                this.setState({ showing: true })
              }}
              blur={() => {
                this.setState({ focus: false })
              }}
            />
          </Form>
        )}
        onSubmit={(values, { setSubmitting, setFieldValue }) => {
          this.props
            .inviteUsers(
              values.users.map(email => ({ email })),
              parseInt(values.shareLevel, 10)
            )
            .then(() => {
              setFieldValue('users', [])
              setSubmitting(false)
              this.setState({ showing: false })
            })
        }}
        initialValues={{
          users: [],
          shareLevel: VIEWER
        }}
        validate={values => {
          let errors = {}
          if (!values.users.length) {
            errors.users = 'Let us know who you want to share with'
          } else {
            const emailErrors = []
            values.users.forEach(email => {
              if (email && !emailRegex.test(email)) {
                emailErrors.push(`"${email}" is not a valid email address`)
              }
            })
            if (emailErrors.length) errors.users = emailErrors.join(', ')
          }
          if (!values.shareLevel) {
            errors.email = 'Please choose an access level'
          }
          return errors
        }}
      />
    )
  }

  static propTypes = {
    inviteUsers: PropTypes.func.isRequired
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteFormContainer)
